import React, {useEffect} from 'react'
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form'
import {IApplicationFormData} from '../../models/application-form'
import {createEmptyEmployment, createEmptyIncome} from './sections/employmentDraft'
import EmploymentIncomeSection from './sections/EmploymentIncomeSection'

interface IncomeStepProps {
  register: UseFormRegister<IApplicationFormData>
  control: Control<IApplicationFormData>
  errors?: FieldErrors<IApplicationFormData>
  setValue: UseFormSetValue<IApplicationFormData>
  watch: UseFormWatch<IApplicationFormData>
  trigger?: UseFormTrigger<IApplicationFormData>
  triggerValidation?: () => Promise<boolean>
}

const IncomeStep: React.FC<IncomeStepProps> = ({
  register,
  control,
  errors,
  setValue,
  watch,
  trigger,
  triggerValidation,
}) => {
  const employment = watch('employment')
  const income = watch('income')

  useEffect(() => {
    if (triggerValidation) triggerValidation()
  }, [])

  useEffect(() => {
    if (income) return

    setValue('income', createEmptyIncome(), {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false,
    })
  }, [income, setValue])

  useEffect(() => {
    if (employment) return

    setValue('employment', createEmptyEmployment(), {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false,
    })
  }, [employment, setValue])

  return (
    <div className='d-grid gap-4'>
      <EmploymentIncomeSection
        register={register}
        control={control}
        errors={errors}
        watch={watch}
        trigger={trigger}
        setValue={setValue}
      />
    </div>
  )
}

export default IncomeStep
